// Role-aware welcome tour content — V1 invite-only (Priority 7 Day 5).
//
// Per onboarding-spec.md §6 Step 6: 3-step tour skippable; after tour
// redirect to role-default dashboard. Wave 2: helper auto-assignment +
// capability multi-select per V2 ceremony.
//
// The bilingual content now lives in i18n/onboarding/role-tours.ts. This
// module keeps the English map (ROLE_TOURS) and the types for callers that
// only need role keys / routes; UI text should come from roleToursI18n.

import { roleToursI18n } from '../../i18n/onboarding/role-tours'

export type { TourStep, ChecklistItem, RoleTour } from '../../i18n/onboarding/role-tours'
export { roleToursI18n }

export const ROLE_TOURS = roleToursI18n.en
